import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { LimitFlowProposalService } from '../../../service/limit-flow-proposal/limit-flow-proposal.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { ActivatedRoute, Router } from '@angular/router';

export interface SendToCtcModel {
	accountClientID: string,
	proposalID: string,
	proposalCTC: string;
	target: string;
}

@Component({
	selector: 'app-send-to-ctc',
	templateUrl: './send-to-ctc.component.html',
	styleUrls: ['./send-to-ctc.component.scss']
})
export class SendToCtcComponent extends DialogComponent<SendToCtcModel, boolean> implements SendToCtcModel {

	accountClientID: string;
	proposalID: string;
	proposalCTC: string;
	target: string;

	ctc: any[] = [];
	ctcs: any[] = [];

	constructor(dialogService: DialogService, private router: Router, private flashMessagesService: FlashMessagesService, private limitFlowProposalService: LimitFlowProposalService) {
		super(dialogService);
	}

	ngOnInit() {
		this.getCtcByAccountClient(this.accountClientID);
	}

	getCtcByAccountClient(id) {
		this.limitFlowProposalService.getCtcByAccountClient(id).subscribe(result => {
			if (result.Success) {
				this.ctcs = result.Result;

				if (this.ctcs.length === 1) {
					this.ctc = this.ctcs[0];
					this.sendProposal(this.ctc);
				} else {
					for (var key in this.ctcs) {
						var obj = this.ctcs[key];
						if (obj.CodigoSap === this.proposalCTC) {
							this.ctc = obj;
						}
					}
				}
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	sendProposal(obj) {
		if (this.target === 'ctc') {
			this.sendToCtc(obj);
		} else if (this.target === 'preAnalise') {
			this.sendToPreAnalise(obj);
		} else if (this.target === 'comite') {
			this.limitFlowProposalService.proposalObj['CodigoSap'] = obj.CodigoSap;
			this.confirm();
		} else {
			this.flashMessagesService.show("Ocorreu um erro ao tentar mover a proposta.", { cssClass: 'alert-danger', timeout: 6000 });
		}
	}

	sendToCtc(obj) {
		var data = {
			ID: this.proposalID,
			CodigoSap: obj.CodigoSap
		}

		this.limitFlowProposalService.sendToCtc(data).subscribe(result => {
			if (result.Success) {
				console.log("Send to CTC", result);
				this.flashMessagesService.show("Proposta enviada ao CTC", { cssClass: 'alert-success', timeout: 6000 });
				this.confirm();
			} else {
				this.close();
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	sendToPreAnalise(obj) {
		var data = {
			ID: this.proposalID,
			CodigoSap: obj.CodigoSap
		}

		this.limitFlowProposalService.sendPreAnalise(data).subscribe(result => {
			if (result.Success) {
				console.log("Send To Pre Analise: ", result.Result);
				this.flashMessagesService.show("Proposta enviada para Pré Análise", { cssClass: 'alert-success', timeout: 6000 });
				this.confirm();
			} else {
				this.close();
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			return false;
		});
	}

	confirm() {
		this.result = true;
		this.close();
	}
}



// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/actions/send-to-ctc/send-to-ctc.component.ts